import { apiRequest } from "./apiService";

const noWorkspaceScope = { workspaceScoped: false };

export const getTeamMembers = () => apiRequest("/team/members", "GET", null, noWorkspaceScope);
export const getTeamInvitations = () => apiRequest("/team/invitations", "GET", null, noWorkspaceScope);
export const inviteTeamMember = (body) => apiRequest("/team/invitations", "POST", body, noWorkspaceScope);
export const revokeTeamInvitation = (invitationId) =>
  apiRequest(`/team/invitations/${encodeURIComponent(invitationId)}`, "DELETE", null, noWorkspaceScope);
export const acceptTeamInvitation = (token) =>
  apiRequest("/team/invitations/accept", "POST", { token }, noWorkspaceScope);
export const updateTeamMember = (userId, body) =>
  apiRequest(`/team/members/${encodeURIComponent(userId)}`, "PATCH", body, noWorkspaceScope);
export const removeTeamMember = (userId) =>
  apiRequest(`/team/members/${encodeURIComponent(userId)}`, "DELETE", null, noWorkspaceScope);
